import { createContext, useContext } from "react";

/**
 * Плеер приостановлен: поверх него открыт диалог (например, похожее видео
 * поверх прокси-страницы) или он играет в фоне.
 *
 * Основное видео получает suspended пропом, а рекламные плееры живут в своём
 * поддереве (пре-ролл, пауза-ролл, пост-ролл, лайв-адв) и пропом их достать
 * неудобно — поэтому значение раздаётся контекстом из Player.
 */
const PlayerSuspendedContext = createContext(false);

export function usePlayerSuspended() {
  return useContext(PlayerSuspendedContext);
}

export default PlayerSuspendedContext;
